import CsrRegSuccess from './CsrRegSuccess';

export default CsrRegSuccess;
